module.exports = __webpack_public_path__ + "static/media/banner4.86540e21.jpg";